import ReportingContainer from '../../../containers/Appointment/Reporting';

function Reporting() {
  return <ReportingContainer />;
}

export default Reporting;
